import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=ab06e114&scoped=true"
import script from "./VFooter.vue?vue&type=script&lang=ts"
export * from "./VFooter.vue?vue&type=script&lang=ts"
import style0 from "./VFooter.vue?vue&type=style&index=0&id=ab06e114&prod&lang=scss&scoped=true"
import style1 from "./VFooter.vue?vue&type=style&index=1&id=ab06e114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab06e114",
  null
  
)

export default component.exports